import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=1220adfe&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1220adfe')) {
      api.createRecord('1220adfe', component.options)
    } else {
      api.reload('1220adfe', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=1220adfe&", function () {
      api.rerender('1220adfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4txOZF42RsXAR/JS/comp/openstreetmap.vue"
export default component.exports